import React, { FC } from 'react'

import styles from './Sitemap.module.scss'
import SitemapBreadcrumbs, { Breadcrumb } from './SitemapBreadcrumbs'

interface SitemapPageProps {
  title: string
  breadcrumbs?: Breadcrumb[]
  children?: React.ReactNode
}

const SitemapPage: FC<SitemapPageProps> = ({
  breadcrumbs,
  title,
  children,
}) => {
  return (
    <section className={styles.sitemap}>
      <SitemapBreadcrumbs breadcrumbs={breadcrumbs} />
      <h2>{title}</h2>
      <section className={styles.body}>{children}</section>
    </section>
  )
}

export default SitemapPage
